import { useI18n } from '@goparrot-dashboard/i18n';
import * as React from 'react';
import { SignInLink } from './SignInLink';

export const SignInSubtitle: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();
  return (
    <p className="tw-mt-8 tw-mb-5 tw-text-base tw-text-black">
      {getIntlString('cta.signIn')} <SignInLink />
    </p>
  );
};
